import { ReactNode } from "react"
import ProgressBar from "@ramonak/react-progress-bar"
import CloseIcon from "../../../../../assets/icons/react-svg/NewCloseIcon"
import VideoIcon from "../../../../../assets/icons/react-svg/Video"
import styles from '../FeedbackPage.module.css'
import { useLanguage } from "../../../../../context/LanguageContext"

interface IFileUploadProgress {
    fileName: string,
    fileSize: string,
    progress: number,
    onCancel: () => void,
    children?: ReactNode
}

const FileUploadProgress = ({ fileName, fileSize, progress, onCancel, children }: IFileUploadProgress) => {
    const { t } = useLanguage();
    return (
        <div className={styles.uploadProgressContainer}>
            <h4 className={styles.uploadProgressTitle}>{t('upload_record_file')}</h4>
            <div className={styles.uploadProgressCard}>
                <div className={styles.uploadProgressHeader}>
                    <div className={styles.uploadProgressFileInfo}>
                        <div className={styles.uploadProgressIcon}>
                            <VideoIcon />
                        </div>
                        <div className={styles.uploadProgressDetails}>
                            <div className={styles.uploadProgressFileName}>{fileName}</div>
                            <div className={styles.uploadProgressFileSize}>{fileSize}</div>
                        </div>
                    </div>
                    <button 
                        className={styles.uploadProgressCloseButton}
                        onClick={onCancel}
                        type="button"
                    >
                        <CloseIcon />
                    </button>
                </div>
                <div className={styles.uploadProgressBarContainer}>
                    <ProgressBar
                        completed={progress}
                        customLabel={`${progress}%`}
                        transitionTimingFunction="linear"
                        bgColor={"var(--brand, #365d7e)"}
                        baseBgColor={"#e5e7eb"}
                        animateOnRender={true}
                        height={"12px"}
                        borderRadius={"4px"}
                        labelAlignment="right"
                        labelColor="#fff"
                        labelSize="12px"
                    />
                </div>
            </div>
            {children}
        </div>
    )
}

export default FileUploadProgress
